import type { FC, ReactNode } from 'react'
import type { DocumentSection } from '@/components/generals/document-page'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { DocumentPage } from '@/components/generals/document-page'
import { siteConfig } from '@/constants/site'

const sections: DocumentSection[] = [
    {
        heading: 'What we collect',
        paragraphs: [
            'When you place an order we collect your name, email address, shipping address and payment confirmation. We never see or store your full card number; that stays with our payment processor.',
            'When you subscribe to our newsletter we collect your email address and nothing else. When you contact support we keep the message you sent so we can answer it properly.'
        ]
    },
    {
        heading: 'Why we collect it',
        paragraphs: [
            'To fulfil your order, to answer your questions, to send the updates you asked for, and to understand at an aggregate level which parts of the site people find useful.',
            'We do not sell your data, we do not rent it, and we do not share it with advertisers.'
        ]
    },
    {
        heading: 'Analytics',
        paragraphs: [
            'We measure page views and referral sources in aggregate so we can improve the site. These measurements are not tied to your identity and are not used to build a profile of you.'
        ]
    },
    {
        heading: 'How long we keep it',
        paragraphs: [
            'Order records are retained for seven years because tax law requires it. Support messages are kept for two years. Newsletter subscriptions are kept until you unsubscribe, which you can do from any email we send.'
        ]
    },
    {
        heading: 'Your rights',
        paragraphs: [
            'You can ask us for a copy of the data we hold about you, ask us to correct it, or ask us to delete it. We will respond within 30 days.',
            `Send any of those requests to ${siteConfig.email} and we will handle it directly, without making you jump through a form.`
        ]
    },
    {
        heading: 'Security',
        paragraphs: [
            'All traffic to this site is encrypted in transit. Access to customer records inside the company is limited to the people who need it to do their job.'
        ]
    },
    {
        heading: 'Changes',
        paragraphs: [
            'If we change this policy in a way that materially affects you, we will say so on this page and, where we hold your email address, tell you directly.'
        ]
    }
]

const PrivacyPolicy: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo
                title='Privacy policy'
                description='What Nuvéa collects, why we collect it, how long we keep it, and the control you keep over your own data.'
            />

            <DocumentPage
                titleLines={['Privacy', 'Policy']}
                standfirst='We respect your inbox as much as your skin. This page explains exactly what we collect, why, and what you can ask us to do with it.'
                updatedOn='January 2026'
                sections={sections}
            />
        </Layout>
    )
}

export default PrivacyPolicy
